import { FC, useState } from 'react';

import { startOfMonth } from 'date-fns';

import Button, { ButtonIconPosition, ButtonKind } from 'bloko/blocks/button';
import { toISO } from 'bloko/blocks/calendar/datesHelper';
import IntervalCalendarPicker from 'bloko/blocks/calendar/IntervalCalendarPicker';
import Icon, { IconScale, IconView } from 'bloko/blocks/icon';
import Loading from 'bloko/blocks/loading';
import Modal, { ModalFooter, ModalTitle } from 'bloko/blocks/modal';
import Text, { TextSize } from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import { downloadLeads } from 'components/Dashboard/LeadsModal/downloadLeads';

import { useDispatch } from 'store/utils';

import styles from 'components/Dashboard/LeadsModal/LeadsModal.module.less';

interface LeadsModal {
    visible: boolean;
    onClose: () => void;
}

const Trls = {
    title: 'dashboard.title.leads.modal.title',
    description: 'dashboard.title.leads.modal.description',
    download: 'dashboard.title.leads.modal.download',
};

const initialDates = {
    start: toISO(startOfMonth(new Date())),
    end: toISO(new Date()),
};

const LeadsModal: FC<LeadsModal> = ({ visible, onClose }) => {
    const trls = useTrls();
    const dispatch = useDispatch();
    const [dates, setDates] = useState(initialDates);
    const [isLoading, setIsLoading] = useState(false);
    const { start, end } = dates;

    const downloadButtonClickHandler = () => {
        void dispatch(downloadLeads({ dates, callback: setIsLoading })).then(() => {
            onClose();
            setDates(initialDates);
        });
    };

    return (
        <Modal visible={visible} onClose={onClose}>
            <div className={styles.leadsModal}>
                <ModalTitle>{trls(Trls.title)}</ModalTitle>
                <VSpacing base={4} />
                <Text size={TextSize.Large}>{trls(Trls.description)}</Text>
                <VSpacing base={6} />
                <IntervalCalendarPicker
                    initialDate={start}
                    start={start}
                    end={end}
                    onDateClick={({ start, end }) => setDates({ start, end })}
                />
                <VSpacing base={3} />
                <ModalFooter>
                    <Button
                        icon={!isLoading ? <Icon view={IconView.ArrowLine} scale={IconScale.Small} /> : <Loading />}
                        iconPosition={ButtonIconPosition.Left}
                        kind={ButtonKind.Primary}
                        disabled={isLoading}
                        onClick={downloadButtonClickHandler}
                    >
                        {trls(Trls.download)}
                    </Button>
                </ModalFooter>
            </div>
        </Modal>
    );
};

export default LeadsModal;
